import { FormFieldsData } from 'framework/form';
import { ReviewTimeTrackCommand } from './types';
import useTimeTrackingService from './useTimeTrackingService';

const useTimeTrackChangeRequestService = () => {
  const timeTrackingService = useTimeTrackingService();

  const getChangeRequest = async (requestId: string) => {
    return timeTrackingService.getChangeRequest(requestId);
  };

  const reviewRequest = async (data: FormFieldsData, isLegacy: boolean): Promise<void> => {
    const reviewData: ReviewTimeTrackCommand = {
      changeRequestId: data.changeRequestId,
      isApproved: data.isApproved,
      reason: data.reason,
    };

    await timeTrackingService.reviewChangeRequest(reviewData, isLegacy);
  };

  const getValidationSchema = () => {
    return Promise.resolve({
      changeRequestId: { type: 'string', required: true },
      isApproved: { type: 'enum', required: true },
      reason: {
        type: 'string',
        required: {
          value: true,
          when: {
            isApproved: {
              eq: 'NO',
            },
          },
          message: 'Reason is required when rejecting the request',
        },
      },
    });
  };

  return { getChangeRequest, reviewRequest, getValidationSchema };
};

export default useTimeTrackChangeRequestService;
